import { useEffect } from "react";

const SELECTOR = ".btn-gold, .btn-ghost";
const BUTTON_MAX_PULL = 7;
const CONTENT_MAX_PULL = 11;

const spawnSparkles = (x, y) => {
  const layer = document.getElementById("fx-layer");
  if (!layer || !window.gsap) return;
  for (let i = 0; i < 10; i++) {
    const dot = document.createElement("div");
    dot.className = "sparkle-particle";
    dot.style.left = `${x}px`;
    dot.style.top = `${y}px`;
    layer.appendChild(dot);
    const angle = Math.random() * Math.PI * 2;
    const dist = 40 + Math.random() * 60;
    window.gsap.to(dot, {
      x: Math.cos(angle) * dist,
      y: Math.sin(angle) * dist,
      opacity: 0,
      scale: 0.2,
      duration: 0.7 + Math.random() * 0.3,
      ease: "power2.out",
      onComplete: () => dot.remove(),
    });
  }
};

export const useButtonFx = () => {
  useEffect(() => {
    const isTouch = window.matchMedia("(hover: none), (pointer: coarse)").matches;
    const cleanups = [];

    if (!isTouch) {
      document.querySelectorAll(SELECTOR).forEach((btn) => {
        const content = btn.querySelector(".btn-content") || btn;

        const handleMove = (e) => {
          const rect = btn.getBoundingClientRect();
          const cx = rect.left + rect.width / 2;
          const cy = rect.top + rect.height / 2;
          const ratioX = Math.max(-1, Math.min(1, (e.clientX - cx) / (rect.width / 2)));
          const ratioY = Math.max(-1, Math.min(1, (e.clientY - cy) / (rect.height / 2)));

          btn.style.setProperty("--mx", `${ratioX * BUTTON_MAX_PULL}px`);
          btn.style.setProperty("--my", `${ratioY * BUTTON_MAX_PULL}px`);
          if (content !== btn) {
            content.style.transform = `translate(${ratioX * CONTENT_MAX_PULL}px, ${ratioY * CONTENT_MAX_PULL}px)`;
          }
        };

        const handleLeave = () => {
          if (window.gsap) {
            window.gsap.to(btn, { "--mx": "0px", "--my": "0px", duration: 0.6, ease: "elastic.out(1, 0.5)" });
            if (content !== btn) {
              window.gsap.to(content, { x: 0, y: 0, duration: 0.6, ease: "elastic.out(1, 0.5)" });
            }
          } else {
            btn.style.setProperty("--mx", "0px");
            btn.style.setProperty("--my", "0px");
            if (content !== btn) content.style.transform = "translate(0px, 0px)";
          }
        };

        btn.addEventListener("mouseenter", handleMove);
        btn.addEventListener("mousemove", handleMove);
        btn.addEventListener("mouseleave", handleLeave);
        cleanups.push(() => {
          btn.removeEventListener("mouseenter", handleMove);
          btn.removeEventListener("mousemove", handleMove);
          btn.removeEventListener("mouseleave", handleLeave);
        });
      });
    }

    const handleClick = (e) => {
      const btn = e.target.closest(SELECTOR);
      if (!btn) return;
      spawnSparkles(e.clientX, e.clientY);
    };
    window.addEventListener("click", handleClick);

    return () => {
      cleanups.forEach((fn) => fn());
      window.removeEventListener("click", handleClick);
    };
  }, []);
};
